import { RecordsTable } from 'dyl-components';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Header } from './Header';
import "../index.scss"
import { Row } from './Row';
import broadcastActions from 'actions/broadcast';
const MessageHistory = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [filters, setFilters] = useState({
        message_type: params.get('message_type')?.split(','),
        permission_type: params.get('permission_type')?.split(','),
        user: params.get('user')?.split(','),
    })

    const onFilter = async (_, { name, value }) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }
    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`/settings/broadcast-message/message-history${query_string ? `?${query_string}` : ''}`);
    }

    const { messages = [], count = 0, isReadingBroadcastMessage } = useSelector(state => {
        return {
            messages : state.broadcast.broadcast_messages,
            count : state.broadcast.broadcast_messages_count,
            isReadingBroadcastMessage : state.broadcast.isReadingBroadcastMessage,
        } || {}
    });
    useEffect(() => {
        const query = new URLSearchParams(params);
        const { message_type, permission_type, user_id } = filters;
        if (message_type?.length > 0) {
            query.set('message_type', message_type.join(','));
        } else {
            query.delete('message_type');
        }
        if (permission_type?.length > 0) {
            query.set('permission_type', permission_type.join(','));
        } else {
            query.delete('permission_type');
        }
        if (user_id?.length > 0) {
            query.set('user_id', user_id.join(','));
        } else {
            query.delete('user_id');
        }
        const query_string = query.toString();
        navigate(`/settings/broadcast-message/message-history${query_string ? `?${query_string}` : ''}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    useEffect(() => {
        const queryParameters = {
            page: 1,
            limit: 25,
            ...Object.fromEntries(params),
            start_time: params.get("start") || undefined,
            end_time: params.get("end") || undefined,
        }
        delete queryParameters.start;
        delete queryParameters.end;

        dispatch(broadcastActions.getBroadcastMessages(queryParameters));
    }, [params, dispatch]);

    useEffect(()=>{
        dispatch(broadcastActions.getCreatedByUsers())
    },[dispatch])

    return (
            <RecordsTable
                tableBodyClassName='MessageHistoryTable'
                isTableLoading={isReadingBroadcastMessage}
                isSearchResultEmpty={count === 0 && (params.get('message_type') || params.get('permission_type') || params.get('user'))}
                isTableEmpty={count === 0 && !(params.get('message_type') || params.get('permission_type') || params.get('user'))}
                TableHeader={<Header onFilter={onFilter} />}
                TableRows={messages.map(message => (
                    <Row key={message.id} message={message}/>
                    
                ))}
                noBorder
                recordsCount={count}
                activePage={params.get('page')}
                onPageChange={onPageChange}
                recordsName='Message History'
                emptyListTitle={'No Message History found.'}
                emptySubtitle=' '
            />
    )
}

export default MessageHistory